export const PRICE_REVISION_NEWS_PATH = "/news/x1vjg7lm21xt/";
